export default __webpack_public_path__ + "static/media/powerButtonHover.b6a38bcc.svg";